import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "document-block col-12" }
const _hoisted_2 = { class: "document-block__wrapper col-12 row items-start" }
const _hoisted_3 = { class: "document-item__wrapper row col-12 col-lg-9 justify-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_information_file_item = _resolveComponent("information-file-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, {
      appear: "",
      "enter-active-class": "animated fadeIn slower delay-2s"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "col-lg-3 q-mb-md q-pr-lg" }, [
            _createElementVNode("div", { class: "document-block__title" }, "Документы"),
            _createElementVNode("div", { class: "document-block__subtitle" }, "Справочная информация")
          ], -1)),
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.FILES, (file, index) => {
              return (_openBlock(), _createBlock(_component_information_file_item, {
                key: index,
                file: file,
                "is-last-item": index === _ctx.getLastItemIndex
              }, null, 8, ["file", "is-last-item"]))
            }), 128))
          ])
        ])
      ]),
      _: 1
    })
  ]))
}